import { nonEmptyStringValidator, viewBoxStringValidator } from '@vista-digital/occ-domain';
import { Validator } from '@vista-digital/validator';
export const iconAssetValidator = Validator.object({
    name: nonEmptyStringValidator,
    viewBox: viewBoxStringValidator
});
//# sourceMappingURL=icon-asset.js.map